import { Component, OnInit } from '@angular/core';
import * as qs from 'query-string';
import { AmorphicService } from '../../services/amorphic/amorphic.service';

@Component({
  moduleId: module.id,
  selector: 'acknowledgement',
  templateUrl: './acknowledgement.component.html',
})
export class InsuredAcknowledgementComponent implements OnInit {
  controller;
  dataIsLoaded: boolean;
  ack: boolean;

  constructor(private amorphicService: AmorphicService) {
    this.controller = amorphicService.controller;
  }

  async ngOnInit() {
    const parsed = qs.parse(location.search);
    const ret = await this.controller.insuredAcknowledgement(parsed.jwtToken);
    this.dataIsLoaded = ret.loaded;
    this.ack = ret.data;
  }

  close(): void {
    window.close();
  }
}
